import { useMatch } from "react-router-dom";

import { BOT_ROUTE, PARTY_MARKET_SECTION_PATH, PARTY_SECTION_PATH } from "@/app/constants/routes";
import { LayerType } from "@/app/routing/types";
import { BotType } from "@/shared/routing";

const BOT_LAYER_MAP: Record<BotType, LayerType> = {
	CEX: "cex-bot",
	DEX: "dex-bot",
	DEX_V2: "dex-v2-bot",
	DEX_NE: "dex-ne-bot",
};

const useCheckLayerMatch = (path: string) => {
	const route = useMatch(path);

	return Boolean(route);
};

const useCheckBotLayerMatch = () => {
	const route = useMatch(BOT_ROUTE);

	if (!route) return false;

	const { params } = route;

	const { botType } = params;

	if (!botType) return false;

	return BOT_LAYER_MAP[botType as BotType] || false;
};

export const useGetNavigationLayer = (): LayerType => {
	const isMarketLayer = useCheckLayerMatch(PARTY_MARKET_SECTION_PATH);

	const isPartyLayer = useCheckLayerMatch(PARTY_SECTION_PATH);

	const botLayer = useCheckBotLayerMatch();

	if (botLayer) return botLayer;

	if (isMarketLayer) return "market";

	if (isPartyLayer) return "party";

	return "main";
};
